import {
  ObjectEx
} from "vue-objectex";
import {
  toDecimal
} from "@/config/mUtils.js";

export class CourseListEx extends ObjectEx {
  constructor(basicData, priceSettings = null, hasTax = false, taxRate = 0, balanceCost = 0, enrollmentCost = 0, totalPayment = 0) {
    if (Object.typeOf(basicData) !== "array")
      basicData = [];
    let innerOptions = [{
        key: "data",
        value: basicData
      },
      {
        key: "priceSettings",
        value: priceSettings
      },
      {
        key: "hasTax",
        value: hasTax
      },
      {
        key: "taxRate",
        value: taxRate
      },
      {
        key: "balanceCost",
        value: balanceCost
      },
      {
        key: "enrollmentCost",
        value: enrollmentCost
      },
      {
        key: "totalPayment",
        value: totalPayment
      }
    ];

    let innerFuncExtensions = {
      calcBonusPointAmount(bonusPoint) {
        if (
          !!bonusPoint &&
          !!this.priceSettings &&
          this.priceSettings.bonusPointToMoney_BonusPoint > 0
        ) {
          let bonusPointAmount =
            (bonusPoint * this.priceSettings.bonusPointToMoney_Money) /
            this.priceSettings.bonusPointToMoney_BonusPoint;
          bonusPointAmount = toDecimal(bonusPointAmount);
          return bonusPointAmount;
        }
        return 0;
      },
      calcAccountAmount() {  
        let total = this.accountAmount;
        if (total < 0) {
          total = 0;
        }
        return total;
      },
      isValid(){
        if (this.accountAmount < 0 && (this.balanceCost > 0 || this.totalBonusPointAmount > 0)){
          return false;
        }
        return true;
      },
    };
    let innerDefineProps = {
      accountAmount: {
        get() {
          let total =
          this.totalDiscountPrice + this.totalTax -
          this.balanceCost - this.enrollmentCost -
          this.totalBonusPointAmount - this.totalPayment;
 
          return toDecimal(total);
        }
      },
      //总使用积分
      totalBonusPointCost: {
        get() {
          let total = this.data.reduce(
            (sum, x) => sum + x.BonusPointCost,
            0
          );
          return total;
        }
      },
      //总使用积分对应金额
      totalBonusPointAmount: {
        get() {
          return this.calcBonusPointAmount(this.totalBonusPointCost);
        }
      },
      //总折扣价
      totalPrice: {
        get() {
          let total = this.data.reduce(
            (sum, x) => sum + x.Price,
            0
          );
          return total;
        }
      },
      //总优惠价
      totalDiscountPrice: {
        get() {
          let total = this.data.reduce(
            (sum, x) => sum + x.DiscountPrice,
            0
          );
          return total;
        }
      },
      totalPreTax: {
        get() {
          if (this.hasTax && !!this.taxRate) {
            let amountForTax = this.totalDiscountPrice - this.totalBonusPointAmount;
            amountForTax = toDecimal(amountForTax);
            return amountForTax;
          }
          return 0;
        }
      },
      totalTax: {
        get() {
          if (this.hasTax && !!this.taxRate) {
            let tax = this.totalPreTax * this.taxRate;
            return toDecimal(tax);
          }
          return 0;
        }
      },
    };

    super(innerOptions, innerFuncExtensions, innerDefineProps);
  }
}



// WEBPACK FOOTER //
// ./src/components/autonomousEnrolment/workflow/courseListEx.js